import { render, staticRenderFns } from "./addMerchandise.vue?vue&type=template&id=4a4d2730&"
import script from "./addMerchandise.vue?vue&type=script&lang=js&"
export * from "./addMerchandise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports